"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$law = exports.$enactStatement = exports.enactStatementToLines = exports.enactStatementControl = exports.$lawTitleLines = exports.lawToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std = __importStar(require("../../../law/std"));
const std_1 = require("../../../law/std");
const inline_1 = require("../../../node/cst/inline");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_2 = require("../../../util");
const _toc_1 = __importStar(require("./$toc"));
const _preamble_1 = __importStar(require("./$preamble"));
const _mainProvision_1 = __importStar(require("./$mainProvision"));
const _supplProvision_1 = __importStar(require("./$supplProvision"));
const _appdxItem_1 = require("./$appdxItem");
const error_1 = require("../../cst/error");
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
const lawNum_1 = require("../../../law/lawNum");
const el_1 = require("../../../node/el");
/**
 * The renderer for {@link std.Law}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$law.spec.ts) for examples.
 */
const lawToLines = (law, indentTexts) => {
    const lines = [];
    const lawNum = law.children.find(std_1.isLawNum);
    const lawBody = law.children.find(std_1.isLawBody);
    const lawTitle = lawBody?.children.find(std_1.isLawTitle);
    const lawAttr = {};
    const { LawType: lawTypeFromLawNum } = (0, lawNum_1.parseLawNum)(lawNum?.text() ?? "");
    if (law.attr.LawType && law.attr.LawType !== lawTypeFromLawNum) {
        lawAttr.LawType = law.attr.LawType;
    }
    const attrEntries = [];
    for (const [name, value] of Object.entries(lawAttr)) {
        if (std.defaultAttrs[law.tag][name] === value)
            continue;
        attrEntries.push(new inline_1.AttrEntry(`[${name}="${value}"]`, [name, value], null, "", null));
    }
    if (attrEntries.length !== 0) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, attrEntries, [])
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    if (lawTitle) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, lawTitle.children)])
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    if (lawNum) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, ["（", ...lawNum.children, "）"])])
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    if (lawTitle || lawNum) {
        lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
    }
    for (const child of law.children) {
        if ((0, std_1.isLawNum)(child) || (0, std_1.isLawBody)(child)) {
            continue;
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    for (const child of lawBody?.children || []) {
        if ((0, std_1.isLawTitle)(child)) {
            continue;
        }
        else if ((0, std_1.isEnactStatement)(child)) {
            lines.push(...(0, exports.enactStatementToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isTOC)(child)) {
            lines.push(...(0, _toc_1.tocToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isPreamble)(child)) {
            lines.push(...(0, _preamble_1.preambleToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isMainProvision)(child)) {
            lines.push(...(0, _mainProvision_1.mainProvisionToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isSupplProvision)(child)) {
            lines.push(...(0, _supplProvision_1.supplProvisionToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isAppdxItem)(child)) {
            lines.push(...(0, _appdxItem_1.appdxItemToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.lawToLines = lawToLines;
exports.$lawTitleLines = factory_1.factory
    .withName("lawTitleLines")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.virtualIndentDepth === 0) {
        return item;
    }
    else {
        return null;
    }
}), "lawNameLine")
    .and(r => r
    .zeroOrOne(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.virtualIndentDepth === 0
        && (0, util_1.isSingleParentheses)(item)) {
        return item;
    }
    else {
        return null;
    }
})), "lawNumLine")
    .action(({ lawNameLine, lawNumLine }) => {
    return {
        value: { lawNameLine, lawNumLine },
        errors: [],
    };
}));
exports.enactStatementControl = ":enact-statement:";
const enactStatementToLines = (enactStatement, indentTexts) => {
    const lines = [];
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls: [
            new inline_1.Control(exports.enactStatementControl, null, "", null),
        ],
        sentencesArray: [
            new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, enactStatement.children)]),
        ],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    return lines;
};
exports.enactStatementToLines = enactStatementToLines;
exports.$enactStatement = factory_1.factory
    .withName("enactStatement")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.controls.some(c => c.control === exports.enactStatementControl)) {
        return item;
    }
    else {
        return null;
    }
}), "line")
    .action(({ line }) => {
    // for (let i = 0; i < children.value.length; i++) {
    //     children.value[i].attr.Num = `${i + 1}`;
    // }
    const children = (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(line.line.sentencesArray);
    const pos = line.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const enactStatement = (0, std_1.newStdEL)("EnactStatement", {}, children, range);
    return {
        value: enactStatement,
        errors: [],
    };
}));
/**
 * The parser rule for {@link std.Law}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$law.spec.ts) for examples.
 */
exports.$law = factory_1.factory
    .withName("Law")
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.virtualIndentDepth === 0
        && item.line.controls.length === 0
        && item.line.sentencesArray.length === 1
        && item.line.sentencesArray[0].sentences.length === 0
        && item.line.sentencesArray[0].attrEntries.length !== 0) {
        return item.line.sentencesArray[0].attrEntries;
    }
    else {
        return null;
    }
}))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "attrEntriesList")
    .action(({ attrEntriesList }) => Object.fromEntries(attrEntriesList.map(ae => ae.map(a => a.entry)).flat()))), "lawAttr")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(() => exports.$lawTitleLines)
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "lawTitleLines")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(() => exports.$enactStatement)
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "enactStatements")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(() => _toc_1.default)
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "toc")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(() => _preamble_1.default)
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "preambles")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(() => _mainProvision_1.default)
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r.anyOne(), "captured")
    .andOmit(r => r.assertNot(({ captured }) => (captured.type === line_1.LineType.SPR)
    || (captured.type === line_1.LineType.APP)
    || (captured.type === line_1.LineType.ART)
    || (captured.type === line_1.LineType.ARG)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))))))), "mainProvisionAndErrors")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _supplProvision_1.default)
    .or(() => _appdxItem_1.$appdxFig)
    .or(() => _appdxItem_1.$appdxTable)
    .or(() => _appdxItem_1.$appdxStyle)
    .or(() => _appdxItem_1.$appdxNote)
    .or(() => _appdxItem_1.$appdxFormat)
    .or(() => _appdxItem_1.$appdx)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .andOmit(r => r.nextIsNot(r => r.oneMatch(({ item }) => item.type === line_1.LineType.SPR || item.type === line_1.LineType.APP ? item : null)))
    .and(r => r.anyOne())
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))))))), "supplOrAppdxItemAndErrors")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r.anyOne())
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "notCapturedErrorLines")
    .action(({ lawAttr, lawTitleLines, enactStatements, toc, preambles, mainProvisionAndErrors, supplOrAppdxItemAndErrors, notCapturedErrorLines }) => {
    const errors = [];
    const law = (0, std_1.newStdEL)("Law", {
        Lang: "ja",
    });
    if (lawTitleLines?.value.lawNumLine) {
        const parentheses = (0, util_1.isSingleParentheses)(lawTitleLines.value.lawNumLine);
        const lawNum = parentheses
            ? parentheses.content.text()
            : (0, _sentencesArray_1.sentencesArrayToString)(lawTitleLines.value.lawNumLine.line.sentencesArray);
        law.children.push((0, std_1.newStdEL)("LawNum", {}, [lawNum], lawTitleLines.value.lawNumLine.line.sentencesArrayRange));
        const { Era, Year, LawType, Num } = (0, lawNum_1.parseLawNum)(lawNum);
        if (Era !== null)
            law.attr.Era = Era;
        if (Year !== null)
            law.attr.Year = Year.toString();
        if (LawType !== null)
            law.attr.LawType = LawType;
        law.attr.Num = Num !== null ? Num.toString() : "";
    }
    const lawBody = (0, std_1.newStdEL)("LawBody");
    law.children.push(lawBody);
    Object.assign(law.attr, lawAttr);
    const lawTitle = lawTitleLines && (0, std_1.newStdEL)("LawTitle", {}, (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(lawTitleLines.value.lawNameLine.line.sentencesArray), lawTitleLines.value.lawNameLine.virtualRange);
    if (lawTitle) {
        lawBody.children.push(lawTitle);
    }
    lawBody.children.push(...enactStatements.map(v => v.value));
    errors.push(...enactStatements.map(v => v.errors).flat());
    if (toc) {
        lawBody.children.push(toc.value);
        errors.push(...toc.errors);
    }
    for (const preamble of preambles) {
        lawBody.children.push(preamble.value);
        errors.push(...preamble.errors);
    }
    for (const [mainProvision, errorLines] of mainProvisionAndErrors) {
        const lastChild = lawBody.children.length > 0 ? lawBody.children[lawBody.children.length - 1] : null;
        if (lastChild && (0, std_1.isMainProvision)(lastChild)) {
            lastChild.children.push(...mainProvision.value.children);
            Object.assign(lastChild.attr, { ...mainProvision.value.attr, ...lastChild.attr });
        }
        else {
            lawBody.children.push(mainProvision.value);
            if (lawTitle && /\s+抄\s*$/.test(lawTitle.text())) {
                mainProvision.value.attr.Extract = "true";
            }
        }
        errors.push(...mainProvision.errors);
        for (const errorLine of errorLines) {
            errors.push(new error_1.ErrorMessage(`$law: この行をパースできませんでした。line.type: ${errorLine.type}`, errorLine.virtualRange));
        }
    }
    for (const [supplOrAppdxItem, errorLines] of supplOrAppdxItemAndErrors) {
        lawBody.children.push(supplOrAppdxItem.value);
        errors.push(...supplOrAppdxItem.errors);
        for (const errorLine of errorLines) {
            errors.push(new error_1.ErrorMessage(`$law: この行をパースできませんでした。line.type: ${errorLine.type}`, errorLine.virtualRange));
        }
    }
    for (const errorLine of notCapturedErrorLines) {
        errors.push(new error_1.ErrorMessage(`$law: この行をパースできませんでした。line.type: ${errorLine.type}`, errorLine.virtualRange));
    }
    lawBody.range = (0, el_1.rangeOfELs)(lawBody.children);
    law.range = (0, el_1.rangeOfELs)(law.children);
    return {
        value: law,
        errors,
    };
}));
exports.default = exports.$law;
//# sourceMappingURL=$law.js.map